<template>
  <div class="filter-section" style="float: right">
    <button
      class="btn btn-secondary"
      id="filterButton"
      type="button"
      @click="showFilterOptions = !showFilterOptions"
    >
      <i class="bi bi-funnel"></i> Filter
      <span
        v-if="numOfCurrentFilters > 0"
        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-info"
      >
        {{ numOfCurrentFilters }}
      </span>
    </button>
    <div v-if="showFilterOptions" id="filterPopUp" class="filter-pop-up">
      <div class="filter-pop-up-close">
        <i @click="showFilterOptions = false" class="bi bi-x-lg"></i>
      </div>
      <label for=""><b>Filter Options</b></label>
      <Multiselect
        :class="{
          'filter-fields': true,
          'filter-options': true,
          'ma-bo-120': filterOptOpen
        }"
        v-model="selectedFilters"
        mode="tags"
        :closeOnSelect="false"
        :searchable="true"
        :createTag="true"
        :options="filterOptions"
        :resetAfter="true"
        @open="filterOptOpen = true"
        @close="filterOptOpen = false"
        label="name"
        track-by="name"
        placeholder="Add Filter"
      />

      <div class="row">
        <div class="col-sm-6" v-if="selectedFilters.includes('partner_type')">
          <label for="">শাটেল পাটনার</label>
          <Multiselect
            class="filter-fields"
            v-model="filterValues.partner_type"
            mode="tags"
            :closeOnSelect="true"
            :searchable="true"
            :createTag="true"
            :options="shuttlePartnerOptions"
            :resetAfter="true"
            placeholder="শাটেল পাটনার"
            @keydown.enter="submitHandler()"
          />
        </div>

        <div class="col-sm-6" v-if="selectedFilters.includes('name')">
          <label for="">ব্যবহারকারীর নাম</label>
          <input
            class="form-control filter-fields"
            type="search"
            v-model.trim="user_service.name"
            placeholder="Name"
            aria-label="Search"
            @keydown.enter="submitHandler()"
          />
        </div>

        <div class="col-sm-6" v-if="selectedFilters.includes('user_code')">
          <label for="">ব্যবহারকারীর কোড</label>
          <input
            class="form-control filter-fields"
            type="search"
            v-model.trim="user_service.user_code"
            placeholder="User Code"
            aria-label="Search"
            @keydown.enter="submitHandler()"
          />
        </div>

        <div class="col-sm-6" v-if="selectedFilters.includes('mobile')">
          <label for="">ব্যবহারকারীর মোবাইল</label>
          <input
            class="form-control filter-fields"
            type="search"
            v-model.trim="user_service.mobile"
            placeholder="Mobile"
            aria-label="Search"
            @keydown.enter="submitHandler()"
          />
        </div>

        <div class="col-sm-6" v-if="selectedFilters.includes('role')">
          <label for="">রোল</label>
          <select class="form-select" v-model="filterValues.role">
            <option value="">--Select--</option>
            <option value="Owner">Owner</option>
            <option value="Driver">Driver</option>
          </select>
        </div>

        <div class="col-sm-6" v-if="selectedFilters.includes('tags')">
          <label for="">ট্যাগ</label>
          <input
            class="form-control filter-fields"
            type="search"
            v-model.trim="filterValues.tags"
            placeholder="ট্যাগ"
            aria-label="Search"
            @keydown.enter="submitHandler()"
          />
        </div>

        <div class="col-sm-6" v-if="selectedFilters.includes('car_type')">
          <label for="">গাড়ির ধরন</label>
          <Multiselect
            class="filter-fields"
            v-model="filterValues.car_type"
            mode="tags"
            :closeOnSelect="true"
            :searchable="true"
            :createTag="true"
            :options="carTypeOptions"
            :options-limit="30"
            :resetAfter="true"
            placeholder="গাড়ির ধরন"
            @keydown.enter="submitHandler()"
          />
        </div>

        <div class="col-sm-6" v-if="selectedFilters.includes('car_model')">
          <label for="">গাড়ির মডেল</label>
          <Multiselect
            class="filter-fields"
            v-model="filterValues.car_model"
            mode="tags"
            :closeOnSelect="true"
            :searchable="true"
            :createTag="true"
            :options="carModelOptions"
            :options-limit="30"
            :resetAfter="true"
            placeholder="গাড়ির মডেল"
            @keydown.enter="submitHandler()"
          />
        </div>
        <div class="col-sm-6" v-if="selectedFilters.includes('drop_location')">
          <label for="">ড্রপ লোকেশন</label>
          <Multiselect
            class="filter-fields"
            v-model="filterValues.drop_location"
            mode="tags"
            :closeOnSelect="true"
            :searchable="true"
            :createTag="true"
            :options="dropLocationsOptions"
            :options-limit="30"
            :resetAfter="true"
            placeholder="ড্রপ লোকেশন"
            @keydown.enter="submitHandler()"
          />
        </div>
        <div
          class="col-sm-6"
          v-if="selectedFilters.includes('garage_location')"
        >
          <label for="">গ্যারেজ লোকেশন</label>
          <Multiselect
            class="filter-fields"
            v-model="filterValues.garage_location"
            mode="tags"
            :closeOnSelect="true"
            :searchable="true"
            :createTag="true"
            :options-limit="30"
            :resetAfter="true"
            :options="parkingLocationsOption"
            placeholder="গ্যারেজ লোকেশন"
            @keydown.enter="submitHandler()"
          />
        </div>
        <div class="col-sm-6" v-if="selectedFilters.includes('is_driven_by')">
          <label for="">ড্রাইভারের ধরন</label>
          <Multiselect
            class="filter-fields"
            v-model="filterValues.is_driven_by"
            mode="tags"
            :closeOnSelect="true"
            :searchable="true"
            :createTag="true"
            :options-limit="30"
            :resetAfter="true"
            :options="is_driven_by"
            placeholder="ড্রাইভারের ধরন"
            @keydown.enter="submitHandler()"
          />
        </div>
        <div class="col-sm-6" v-if="selectedFilters.includes('registered_by')">
          <label for="">নিবন্ধিত</label>
          <Multiselect
            class="filter-fields"
            v-model="filterValues.registered_by"
            mode="tags"
            :closeOnSelect="true"
            :searchable="true"
            :createTag="true"
            :options-limit="30"
            :resetAfter="true"
            :options="registered_by"
            placeholder="নিবন্ধিত"
            @keydown.enter="submitHandler()"
          />
        </div>
      </div>

      <!-- Search Button -->
      <button @click="submitHandler()" class="btn btn-sm btn-primary">
        <i class="bi bi-search"></i> Search
      </button>
    </div>
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';
import http from '../../config/axios';
import userService from '../../config/axiosUserService';

export default {
  components: {
    Multiselect
  },
  props: ['registered_by'],
  data() {
    return {
      showFilterOptions: false,
      selectedFilters: [],
      filterValues: {
        partner_type: [],
        user_code: [],
        car_type: [],
        car_model: [],
        drop_location: [],
        garage_location: [],
        is_driven_by: [],
        registered_by: [],
        role: '',
        tags: ''
      },
      user_service: {
        name: '',
        mobile: '',
        user_code: ''
      },
      numOfCurrentFilters: 0,
      filterOptOpen: false,
      filterOptions: [
        { name: 'শাটেল পাটনার', value: 'partner_type' },
        { name: 'ব্যবহারকারীর নাম', value: 'name' },
        { name: 'ব্যবহারকারীর কোড', value: 'user_code' },
        { name: 'ব্যবহারকারীর মোবাইল', value: 'mobile' },
        { name: 'রোল', value: 'role' },
        { name: 'ট্যাগ', value: 'tags' },
        { name: 'গাড়ির ধরন', value: 'car_type' },
        { name: 'গাড়ির মডেল', value: 'car_model' },
        { name: 'ড্রপ লোকেশন', value: 'drop_location' },
        { name: 'গ্যারেজ লোকেশন', value: 'garage_location' },
        { name: 'ড্রাইভারের ধরন', value: 'is_driven_by' },
        { name: 'নিবন্ধিত', value: 'registered_by' }
      ],
      shuttlePartnerOptions: [
        { value: 'Person', label: 'পার্সন' },
        { value: 'Fleet Owner', label: 'ফ্লিট মালিক' }
      ],
      carTypeOptions: [],
      dropLocationsOptions: [],
      carModelOptions: [],
      parkingLocationsOption: [],
      is_driven_by: ['Self-Driven', 'Driver-Driven']
    };
  },
  mounted() {
    this.getCarModelLists();
    this.getCarTypeLists();
    this.getParkingLocation();
    this.getDropLocation();
  },
  watch: {
    selectedFilters: function () {
      let oldFilterValues = this.filterValues;
      let oldUserServiceValues = this.user_service;
      this.filterValues = {
        partner_type: [],
        user_code: [],
        car_type: [],
        car_model: [],
        drop_location: [],
        garage_location: [],
        is_driven_by: [],
        registered_by: [],
        role: '',
        tags: ''
      };
      this.user_service = {
        name: '',
        mobile: '',
        user_code: ''
      };
      this.selectedFilters.forEach((ele) => {
        if (ele == 'name' || ele == 'mobile' || ele == 'user_code') {
          this.user_service[ele] = oldUserServiceValues[ele];
        } else {
          this.filterValues[ele] = oldFilterValues[ele];
        }
      });
    },
    user_service: {
      handler: function () {
        this.searchData();
      },
      deep: true
    }
  },
  methods: {
    getCarModelLists() {
      http
        .get('v2/cars/models')
        .then((response) => {
          if (response.status === 200) {
            let carModels = response.data.data.carModel;
            carModels.forEach((object) => {
              this.carModelOptions.push({
                value: object.id,
                label: object.name
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getCarTypeLists() {
      http
        .get('v2/cars/types')
        .then((response) => {
          if (response.status === 200) {
            let carTypes = response.data.data.carType;
            carTypes.forEach((object) => {
              this.carTypeOptions.push({
                value: object.id,
                label: object.name
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getParkingLocation() {
      http
        .get('v2/locations/pickdrop')
        .then((response) => {
          if (response.status === 200) {
            let parkingLists = response.data.data;
            parkingLists.forEach((object) => {
              this.parkingLocationsOption.push({
                value: object.id,
                label: object.name
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getDropLocation() {
      http
        .get('v2/locations/pickdrop')
        .then((response) => {
          if (response.status === 200) {
            let dropLocationLists = response.data.data;
            dropLocationLists.forEach((object) => {
              this.dropLocationsOptions.push({
                value: object.id,
                label: object.name
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.isLoading = true));
    },

    submitHandler() {
      this.numOfCurrentFilters = this.selectedFilters.length;
      this.showFilterOptions = false;
      this.$emit('getAllData', this.filterValues);
    },
    searchData() {
      //this.isLoading = true;
      this.filterValues.user_code = [];
      if (
        this.user_service?.name &&
        Object.keys(this.user_service.name).length != 0
      ) {
        var url = `v1/users/search?field=name&return=mobile,name,user_code&key=${
          this.user_service.name || ''
        }`;
        userService
          .get(url)
          .then((response) => {
            let user_info = response.data.data;
            user_info.forEach((users) => {
              this.filterValues.user_code.push(users.user_code);
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
      if (
        this.user_service?.mobile &&
        Object.keys(this.user_service.mobile).length != 0
      ) {
        url = `v1/users/search?field=mobile&return=mobile,name,user_code&key=${
          this.user_service.mobile || ''
        }`;
        userService
          .get(url)
          .then((response) => {
            let user_info = response.data.data;
            user_info.forEach((users) => {
              this.filterValues.user_code.push(users.user_code);
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
      if (
        this.user_service?.user_code &&
        Object.keys(this.user_service.user_code).length != 0
      ) {
        url = `v1/users?fields=mobile,name,user_code&user_code=${
          this.user_service.user_code || ''
        }`;
        userService
          .get(url)
          .then((response) => {
            let user_info = response.data.data;
            user_info.forEach((users) => {
              this.filterValues.user_code.push(users.user_code);
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }
};
</script>

<style scoped>
/* Filter Styles */
.filter-section {
  position: relative;
}
.filter-pop-up {
  position: absolute;
  right: 0;
  top: 45px;
  background: #fff;
  width: 500px;
  padding: 10px 10px 20px 10px;
  box-shadow: 0px 13px 31px 2px rgb(0 0 0 / 16%);
  border-radius: 4px;
  z-index: 2;
}
.filter-pop-up label {
  font-size: 14px;
  font-weight: normal;
}
.filter-pop-up .filter-fields {
  margin-bottom: 15px;
}
.filter-pop-up button {
  float: right;
}
.filter-pop-up-close {
  overflow: hidden;
}
.filter-pop-up-close i {
  float: right;
  cursor: pointer;
}
</style>
